(function() {
	'use strict';

	angular
		.module('app.setup')
		.controller('projectTemplateTasks', projectTemplateTasks);

	projectTemplateTasks.$inject = ['$rootScope', '$scope', '$filter', '$timeout', '$compile', '$uibModal', '$location',
		'projectTemplatesService', 'newProjectService', 'storeService', 'leanProjectAuthService'];

	function projectTemplateTasks($rootScope, $scope, $filter, $timeout, $compile, $uibModal, $location,
								  projectTemplatesService, newProjectService, storeService, leanProjectAuthService) {
		var vm = this;
		var adminConfig = storeService.getState().adminConfig;
		vm.templateNdx = 0;
		vm.projectTemplate = {};
		vm.leanDirFactoryNdx = adminConfig.factory.id;
		vm.dropdownLists = [];
		vm.projectTemplateTasks = [];
		vm.projectTemplateTasksList = [];
		vm.dropdownLists = {};
		vm.details = {};
		vm.saveTask = saveTask;
		vm.deleteTask = deleteTask;
		vm.clear = clear;
		vm.actionIsAllowed = actionIsAllowed;

		function init() {
			var incomingQParam = $location.search();
			if (incomingQParam && incomingQParam.templateNdx) {
				vm.templateNdx = incomingQParam.templateNdx;
			}
			getProjectTemplate();
			vm.details.authzInfo = $rootScope.authz;
			storeService.dispatch(storeService.actionCreators.setAddTaskAllowed(actionIsAllowed('addTask')));
		}

		init();

		function actionIsAllowed(action) {
			return leanProjectAuthService.actionIsAllowed(action, vm.details);
		}

		function getProjectTemplate() {
			projectTemplatesService.getProjectTemplate(vm.templateNdx, adminConfig.factory.id).then(function(response){
				if (response && response.status && response.status >= 200 && response.status < 400) {
					if (response.data) {
						vm.projectTemplate = response.data;
					}
				} else {
					vm.notFound = true;
				}
			});
		}
		
		function saveTask(callback, task) {
			var addTemplateTaskFormScope = $scope.$new();
			addTemplateTaskFormScope.action = (task && task.ndx) ? 'Edit' : 'Add';
			addTemplateTaskFormScope.templateNdx = vm.templateNdx;
			addTemplateTaskFormScope.task = task;
			var opts = {
				scope: addTemplateTaskFormScope,
				templateUrl: '/application/f/setup/projects/templates/tasks/add-task.html',
				size: 'sm',
				backdrop: 'static'
			};

			var instance = $uibModal.open(opts);
			addTemplateTaskFormScope.closeDialog = function() {
				instance.close();
				addTemplateTaskFormScope.$destroy();
			};

			addTemplateTaskFormScope.result = function(message, isSuccessful) {
				$rootScope.$emit('toast', {'message': message, 'success': isSuccessful});
				if (isSuccessful && callback) {
					callback();
				}
				if (isSuccessful || message === '') {
					instance.close();
					addTemplateTaskFormScope.$destroy();
				}
			};
		}
		
		function deleteTask(taskNdx, callback) {
			var confirmScope = $scope.$new();
			confirmScope.templateNdx = vm.templateNdx;
			confirmScope.taskNdx = taskNdx;
			confirmScope.additionalText = 'delete this task';
			confirmScope.buttonText = 'Delete';
			var opts = {
				scope: confirmScope,
				templateUrl: '/application/f/core/confirm.html'
			};

			var instance = $uibModal.open(opts);
			confirmScope.closeDialog = function() {
				instance.close();
				confirmScope.$destroy();
			};

			confirmScope.yes = function() {
				var templateNdx = confirmScope.templateNdx;
				var templateTaskNdx = confirmScope.taskNdx;
				instance.close();
				confirmScope.$destroy();
				projectTemplatesService.deleteTemplateTask(templateNdx, templateTaskNdx, adminConfig.factory.id).then(function(message) {
					var isSuccessful = (message === 'Template task deleted successfully');
					$rootScope.$emit('toast', {'message': message, 'success': isSuccessful});
					if (isSuccessful && callback) {
						callback();
					}
				});
			};
		}

		function clear() {
			vm.editFieldValue = null;
		}
	}
})();
